import type { IMosaicTocExpanded, ITocActionSetTypeFilter } from "./interface";

/**
 * Updates which ToC item types are visible.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action containing the visible item types.
 * @returns The updated ToC state with the new type filter.
 */
export const toc_setTypeFilter = (
  state: IMosaicTocExpanded,
  action: ITocActionSetTypeFilter,
): IMosaicTocExpanded => ({
  ...state,
  showTypes: action.showTypes,
});
